import { render, staticRenderFns } from "./SettingsComissions.vue?vue&type=template&id=7dcf8b12&"
import script from "./SettingsComissions.vue?vue&type=script&lang=js&"
export * from "./SettingsComissions.vue?vue&type=script&lang=js&"
import style0 from "./SettingsComissions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports